import { Alert, styled } from '@mui/material';

interface DialogAlertSectionProps {
    error?: string;
}

export default function DialogAlertSection({ error }: DialogAlertSectionProps) {
    if (!error) {
        return null;
    }

    return (
        <Root severity="error">
            { error }
        </Root>
    );
}

const Root = styled(Alert)(({ theme }) => ({
    marginTop: theme.spacing(6)
}));
